module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat-locked-4f9acaba19022506e74735b4c81c43b1.svg";